import { createAction } from '@reduxjs/toolkit';

const ANALYTICS_READY = 'SPLIT_READY';

export const analyticsReady = createAction(ANALYTICS_READY);
